import { api } from './api';
import type { EndUserListResponse } from '../types/endUser';

export const projectEndUsersApi = {
  list: (projectId: string) => api.get<EndUserListResponse>(`/api/projects/${projectId}/end-users`),
};
